(function (Drupal, $, once) {
  'use strict';

  // Used to make sure Hero CTA block is always added to top of layout builder
  // and can not be removed. Update various other Layout Builder UI elements.
  Drupal.behaviors.ucwsLayout = {
    processedPageFilterTags: false,

    attach(context) {

      // There is a conflict between Bootstrap's 'button.js' functionality and
      // jQuery.ui that prevents the creation of .ui-dialog.ui-dialog-off-canvas
      // close button. One solution would be to load jQuery.ui after Bootstrap's
      // JS but not really feasible to control well in Drupal. Another option is
      // to decouple Bootstrap's button from jQuery to rely on its own JS. To do
      // so, we return $.fn.button to the previously assigned value and give the
      // $().bootstrapBtn the Bootstrap functionality.
      // https://getbootstrap.com/docs/5.0/getting-started/javascript/
      if ($.fn.button && $.fn.button.noConflict !== undefined) {
        $.fn.bootstrapBtn = $.fn.button.noConflict();
      }

      // Layout Builder iFrame Modal module listens for LBIM_REDIRECT which in
      // turn JS clicks '#edit-rebuild-layout' link to trigger a layout rebuild.
      // Our custom 'Edit this block' button appears on both edit & layout tabs
      // so need to ensure the '#edit-rebuild-layout' link exists on view tab.
      // We attach a page reload to the click event, as that is more or less
      // what happens for the layout screen - page reloads and modal closes.
      $(once('loaded', '#block-ucws-theme-local-tasks')).each(function () {
        if ($('#edit-rebuild-layout').length === 0) {
          $('main#content').append('<a id="edit-rebuild-layout" href="#">Rebuild layout</a>');
          $('#edit-rebuild-layout').on('click', function () {
            // This hidden link could exist with a different URL on layout page.
            if ($(this).attr('href') === '#') {
              location.reload();
            }
          });
        }
      });

      // Basic Page - layout builder adjustments
      $(once('loaded', '#layout-builder')).each(function () {

          // Rename 'Add Section' buttons to 'Add layout' buttons
          $('.layout-builder__add-section a').text(function () {
            $(this).text('Add layout');
          });

          // Add a target name to the Hero CTA section
          $('.layout-builder__section').first().addClass('hero-section');

          // Make first 'Add layout' section unavailable
          // (we don't want anything inserted above Hero CTA region)
          $('.hero-section').prev('.layout-builder__add-section').remove();

          // Make the Hero CTA section not removable
          // (should never be possible to delete this one region)
          $('.hero-section .layout-builder__link--remove').remove();

          // Change naming and add description for Hero CTA block
          $('.hero-section .layout-builder__add-block a:first').text('Add Hero CTA Block');
          if ($('.hero-section .layout-builder__add-block .hero-block-description').length === 0) {
            var description = '<p class="hero-block-description">' +
              'A <a href="https://web.ucalgary.ca/technical-resources/live-examples/block-library-guide/hero-cta-block" target="_blank" title="Learn more">Hero CTA block</a> ' +
              'is required for SEO and accessibility purposes.</p>';
            $('.hero-section .layout-builder__add-block').append(description);
          }

          // Prevent more then one Hero block in section
          if ($('.hero-section .block').length) {
            $('.hero-section .layout-builder__add-block').remove();
          }

          // Prevent more than one Banner block in each column of the 50/50 layout.
          $('.layout-builder__layout.layout.col2-50-50-fw .col2-50-fw').each(function () {
            var $column = $(this);
            if ($('.block', $column).length) {
              $('.layout-builder__add-block', $column).remove();
            }
          });

          // Mimic the contextual button's block focus behaviour.
          $(document).on('mouseenter', '.contextual .trigger, .block .block-editing', function () {
            let $region = $(this).parents('.layout-builder-block.contextual-region');
            $region.addClass('focus');
            $(this).on('mouseleave', function () {
              $region.removeClass('focus');
            });
          });

          // Hide the Configure Section links added in Drupal 8.8.
          // (@todo: discovered that this functionality seems broken for us?)
          $('.layout-builder__link--configure').remove();

          // Load page filter tag blocks.
          if (!Drupal.behaviors.ucwsLayout.processedPageFilterTags) {
            Drupal.behaviors.ucwsLayout.refreshPageFilterTags();
          }
      });

      // Add layout: off-canvas sidebar adjustments.
      $(once('loaded', '#drupal-off-canvas .layout-selection')).each(function () {
        // We have to include the default Drupal 'layout_onecol' layout so
        // that we can restrict Hero CTA region blocks (just Hero CTA block).
        // But it shows up in the layout list so remove it to prevent usage.
        $('li a[href*=layout_onecol]', $(this)).parent().remove();
      });

      // Add block: off-canvas sidebar adjustments.
      $(once('loaded', '#drupal-off-canvas .block-categories')).each(function () {
        let $blockAccordions = $('.js-layout-builder-category');

        // Add ID to the main UCalgary block list (mainly for automated tests).
        let $ucalgaryBlocks = $blockAccordions.last();
        $ucalgaryBlocks.attr('id', 'new-ucalgary-blocks');

        // Collapse all but the last main UCalgary block list accordions.
        $blockAccordions.not(':last-child').removeAttr('open');

        // Move UCalgary block collection to top of the list.
        $('#drupal-off-canvas .block-categories').prepend($ucalgaryBlocks);

        // Automatically close the off-canvas sidebar once you add a block.
        $('.links > li > a', $(this)).each(function (index) {
          $(this).on('click', function () {
            $('#drupal-off-canvas-wrapper button.ui-dialog-titlebar-close').trigger('click');
          });
        });
      });

      // Refresh page filter tag blocks when the sidebar is closed.
      $('#drupal-off-canvas').on('dialogclose', function () {
        Drupal.behaviors.ucwsLayout.refreshPageFilterTags('refresh');
      });

    },

    // Function for refreshing page filter tag blocks.
    refreshPageFilterTags: function (origin) {
      if (!Drupal.behaviors.ucwsLayout.processedPageFilterTags || origin === 'refresh') {
        var parent = $('.layout-blocks-ucws-page-filter').parents('.js-layout-builder-block');
        const itemRegion = parent.closest('.js-layout-builder-region');
        const deltaTo = parent.closest('[data-layout-delta]').data('layout-delta');
        Drupal.ajax({
          url: [
            parent.closest('[data-layout-update-url]').data('layout-update-url'),
            deltaTo,
            deltaTo,
            itemRegion.data('region'),
            parent.data('layout-block-uuid'),
            parent.prev('[data-layout-block-uuid]').data('layout-block-uuid'),
          ]
            .filter((element) => element !== undefined)
            .join('/'),
        }).execute().done(function (commands, statusString, ajaxObject) {
          Drupal.behaviors.ucwsLayout.processedPageFilterTags = true;
        });
      }
    }
  };

})(Drupal, jQuery, once);
